import { Injectable } from '@angular/core';

import 'autotrack';
declare var ga: any;

@Injectable()
export class GoogleAnalyticsService {
	constructor() { 
		ga('require', 'cleanUrlTracker');
		ga('require', 'eventTracker');
		ga('require', 'outboundLinkTracker');
		ga('require', 'urlChangeTracker');
	}

	emitEvent(eventCategory, eventAction, eventLabel = null, eventValue = null) {
		ga('send', 'event', {
			eventCategory: eventCategory,
			eventLabel: eventLabel,
			eventAction: eventAction,
			eventValue: eventValue
		});
	}

	emitPage(pagename) {
		ga('set', 'page', pagename);
		// ga('send', 'pageview');
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/addon/ga.service.ts